;(function($){

    function CountDown() {
   	 	var _ =  this;

    	$('.countdown').countdown('2022/10/23 09:30:00', function(event) {
        
          $(this).html(event.strftime(''
          + '<div><h3 class="letter">%D</h3> <span>dias</span></div>'
          + '<div><h3>:</h3></div>'
          + '<div><h3 class="letter">%H</h3> <span>horas</span></div> '
          + '<div><h3>:</h3></div>'
          + '<div><h3 class="letter">%M</h3> <span>minutos</span></div>'
          + '<div><h3>:</h3></div>'
          + '<div><h3 class="letter">%S</h3> <span>segundos</span></div>'
          ));
      });
    
    }
   
   	new CountDown();

}(jQuery));
 
 
 
 
